import React, { PureComponent } from 'react'
import autobind from 'react-autobind'
import { withRouter, Redirect } from 'react-router-dom';
import { api } from '../../lib/api'
import Alert from './../../components/Errors/Alert'
import { ClipLoader } from 'react-spinners'
import _ from 'lodash'

import Dropzone from 'react-dropzone';

import Header from './../../components/Header';
import SuperAdminHeader from './../../components/Header/SuperAdmin';
import Subheader from './../../components/Subheader';
import Footer from './../../components/Footer';
import ModelFileDrop from '../../components/Files/ModelFileDrop';
import { Container, Row, Col } from 'reactstrap';
import Switch from 'react-toggle-switch'
import Select, { AsyncCreatable } from 'react-select';
import MapWithASearchBox from './../../components/MapWithASearchBox';

import { currencyOptions, measuringUnits } from './../../lib/data'
import { RadioGroup, Radio } from 'react-radio-group'
import StatisticsTiles from './../../components/Statistics/StatisticsTiles';
import { ITEMS_PER_PAGE } from '../Pagination/Pagination';
import ErrorHelper from '../ErrorHelper';
import { store } from '../../index';

class ProductPage extends PureComponent {

  constructor(props) {
    super(props);
    autobind(this);

    this.state = {
      productId: this.props.match.params.id,
      name: '',
      hasPlaneTrigger: false,
      hasImageTrigger: false,
      hasGeolocation: false,
      allowConsumerMessaging: false,
      price: '',
      productCurrency: {
        label: 'RON',
        value: 'RON'
      },
      description: '',
      productTags: [],
      acceptedProductImage: null,
      acceptedTriggerImage: null,
      markers: [],
      productLink: '',
      modelFiles: null,
      geoLocateRadius: '',
      productLatitude: '',
      productLongitude: '',
      height: '',
      plane: 'horizontal',
      width: '',
      measuringUnit: {
        label: 'cm',
        value: 'cm'
      },
      price: '',
      currency: '',
      address: '',
      elevation: '',
      modelVerticalPlain: false,
      modelHorizontalPlain: false,
      hasNoTrigger: false,
      modelImageTrigger: false,
      triggerImageSize: '',
      imageTriggerUnit: {
        label: 'cm',
        value: 'cm'
      },
      validationFieldsTouched: {
        name: false,
        productLink: false,
        price: false,
        description: false,
        range: false,
        width: false,
        height: false,
        geoLocateRadius: false,
        triggerImageSize: false,
        modelFiles: false
      }
    };

  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getStatisticsByProduct(this.state.productId);
    this.props.getProduct(this.state.productId)
  }

  componentDidUpdate(prevProps) {
    ErrorHelper.scrollOnError(this.props, prevProps, ['error']);
  }

  componentWillReceiveProps(props) {
    this._updateStateFromProps(props)
  }

  componentWillUnmount() {
    const { clearFurnitureAddProduct } = this.props;
    clearFurnitureAddProduct();
  }

  _updateStateFromProps(props) {

    const { product } = props
    let newState = {}
    let whenDone = () => { }
    if (product) {

      newState = {
        name: product.name,
        price: product.extra.price ? parseFloat(product.extra.price) : '',
        productLink: product.productLink,
        description: product.description,
        productAllowConsumerMessaging: product.allowConsumerMessaging,
        productPath: product.productPath,

        productTags: product.tag.map((tag) => {
          return tag.name
        }),
        productTagOptions: product.tag.map((tag) => {
          return {
            value: tag._id,
            label: tag.name
          }
        }),
        productCurrency: currencyOptions.find(co => co.value === product.extra.currency) || currencyOptions[0],
        geoLocateRadius: product.geolocation.radius,
        productLatitude: product.geolocation.latitude,
        productLongitude: product.geolocation.longitude,
        height: product.extra.size.height,
        width: product.extra.size.width,
        measuringUnit: measuringUnits.find(co => co.value === product.extra.size.uom) || measuringUnits[0],
        address: product.geolocation.address,
        hasGeolocation: product.geolocation.hasGeolocationTrigger,
        elevation: product.trigger.planeElevation,
        plane: product.trigger.planeTriggerType,
        hasNoTrigger: !!product.trigger.hasNoTrigger,
        hasImageTrigger: !!product.trigger.hasImageTrigger,
        hasPlaneTrigger: !!product.trigger.hasPlaneTrigger,

        imageTriggerPath: product.trigger.triggerImagePath,
        triggerImageSize: product.trigger.triggerImageSize ? product.trigger.triggerImageSize : this.state.triggerImageSize,
        imageTriggerUnit: product.trigger.triggerImageUnit ? measuringUnits.find(co => co.value === product.trigger.triggerImageUnit) || measuringUnits[0] : this.state.imageTriggerUnit,
      }

      if (newState.hasGeolocation) {
        newState.geoLocation = [];
        newState.geoLocation.push(
          {
            lat: newState.productLatitude,
            lng: newState.productLongitude,
          }
        )
      }

      const { model } = product
      if (model) {
        newState.modelFiles = model.sourceFiles
        newState.modelErrors = model.conversionErrors
        const { lockedForConversion } = model
        if (lockedForConversion) {
          newState.modelConvertionStarted = lockedForConversion.date
        }
        newState.conversionsBefore = product.conversionsBefore
        newState.modelInvalid = product.modelInvalid
      }
    }

    this.setState(newState, whenDone)

  }
  updateLocation(position) {
    fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + position.lat() + ',' + position.lng() + '&key=AIzaSyBGivnjnSrzq-vZNKBIlfhOMxyTlZb9YB0',
      {
        method: 'GET',
      })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          address: responseJson.results[0].formatted_address
        })
      })
      .catch((error) => {
        console.log(error)
      })

    this.setState({
      productLatitude: position.lat(),
      productLongitude: position.lng(),
    })
  }

  cancelStepThree() {
    this.props.history.push("/products");
  }

  uploadProduct() {
    const dataToUpload = {
      name: this.state.name,
      description: this.state.description,
      currency: this.state.productCurrency.value || 0,
      allowConsumerMessaging: this.state.allowConsumerMessaging,
      tag: this.state.productTags,
      productLink: this.state.productLink,
      modelFiles: this.state.modelFiles,
      width: this.state.width || 0,
      height: this.state.height || 0,
      measuringUnit: this.state.measuringUnit.value,

      hasNoTrigger: !!this.state.hasNoTrigger,
      hasPlaneTrigger: !!this.state.hasPlaneTrigger,
      hasImageTrigger: this.state.hasImageTrigger,
      hasGeolocationTrigger: this.state.hasGeolocation,

      planeTriggerType: this.state.plane,
      elevation: this.state.elevation || 0,
      address: this.state.address
    }

    const { pageType } = this.props;

    if (![null, ''].includes(this.state.triggerImageSize)) {
      dataToUpload.triggerImageSize = Number(this.state.triggerImageSize)
    }
    if (this.state.imageTriggerUnit) {
      dataToUpload.triggerImageUnit = this.state.imageTriggerUnit.value
    }
    if (this.state.acceptedProductImage != null) {
      dataToUpload.productPicture = this.state.acceptedProductImage;
    }
    if (this.state.acceptedTriggerImage != null) {
      dataToUpload.triggerImage = this.state.acceptedTriggerImage;
    }
    if (this.state.productLatitude) {
      dataToUpload.latitude = this.state.productLatitude
    }
    if (this.state.productLongitude) {
      dataToUpload.longitude = this.state.productLongitude
    }
    if (this.state.geoLocateRadius) {
      dataToUpload.geoLocateRadius = parseFloat(this.state.geoLocateRadius)
    }
    if (this.state.price) {
      dataToUpload.price = parseFloat(this.state.price)
    } else {
      dataToUpload.price = 0
    }

    if (pageType === "new") {
      this.updatePaginationData();
    }

    this.props.submitAction(dataToUpload, this.state.productId)
      .then(() => {
        this.resetValidationTouched();
      });
  }

  updatePaginationData() {
    const { productsPaginateDataChanged, sortByIndex, currentPage, productCount } = this.props;
    const lastPage = Math.floor(productCount / ITEMS_PER_PAGE);
    const finalPagination = {
      sortByIndex,
      filterByIndex: 0,
      query: ""
    }

    if (sortByIndex !== 0) {
      finalPagination.currentPage = 0;
    } else {
      finalPagination.currentPage = lastPage;
    }

    productsPaginateDataChanged(finalPagination);
  }

  onDropProductImage(acceptedFiles, rejectedFiles) {
    this.setState({
      acceptedProductImage: acceptedFiles[0]
    });
  }

  renderProductImageUpload(disabled) {
    const imageSource = this.state.acceptedProductImage ? this.state.acceptedProductImage.preview : this.state.productPath
      , imageSourceAction = this.onDropProductImage
      , imageSourceText = 'Upload Product Image'

    return this.renderImageDropSquare(imageSource, imageSourceAction, imageSourceText, disabled)
  }

  renderTriggerImageUpload(disabled) {
    const imageSource = this.state.acceptedTriggerImage ? this.state.acceptedTriggerImage.preview : this.state.imageTriggerPath
      , imageSourceAction = this.onDropTriggerImage
      , imageSourceText = 'Upload Trigger Image'

    return this.renderImageDropSquare(imageSource, imageSourceAction, imageSourceText, disabled)
  }

  renderImageDropSquare(imageSource, imageSourceAction, imageSourceText, disabled) {
    if (imageSource) {
      return (<div className="d-flex justify-content-center">
        <div className="product-upload__image-container">
          <div className="product-upload__image-edit">
            <Dropzone
              onDrop={(accepted, rejected) => { imageSourceAction(accepted, rejected) }}
              className="s7-upload"
              disabled={disabled}>
            </Dropzone>
          </div>
          <img src={imageSource} className="product-upload__image" alt="Product" />
        </div>
      </div>);
    }
    return <div><div className="d-flex justify-content-center mb-2">
      <Dropzone
        onDrop={(accepted, rejected) => { imageSourceAction(accepted, rejected) }}
        className="btn btn-rounded btn-space btn-secondary" disabled={disabled}>
        {imageSourceText}
      </Dropzone>
    </div>
      <p className="text-center mb-1"><em>Recommended: 400x400px</em></p>
      <p className="text-center mb-0"><em>white background jpg</em></p></div>;
  }

  getTagSuggestions(input, callback) {
    api.getTags().then(getTagsResponse => {
      let tags = getTagsResponse.data.payload;
      tags = _.orderBy(tags, ['usageCount'], ['desc']);
      const mappedTags = tags.map(tag => {
        return {
          value: tag._id,
          label: tag.name
        }
      })
      callback(null, {
        options: mappedTags
      })
    }).catch(error => {
      console.log(error)
    })
  }

  updateProductTags(selectedOptions) {
    this.setState({
      productTagOptions: selectedOptions,
      productTags: selectedOptions.map(option => {
        return option.label
      })
    })
  }

  togglehasPlaneTrigger = () => {
    this.setState(prevState => {
      return {
        hasPlaneTrigger: !prevState.hasPlaneTrigger
      };
    });
  }

  togglehasImageTrigger = () => {
    this.setState(prevState => {
      return {
        hasImageTrigger: !prevState.hasImageTrigger,
        triggerImageSize: '',
        validationFieldsTouched: Object.assign(prevState.validationFieldsTouched, { triggerImageSize: true })
      };
    });
  }

  togglehasGeolocation = () => {
    this.setState(prevState => {
      return {
        hasGeolocation: !prevState.hasGeolocation,
        geoLocateRadius: '',
        validationFieldsTouched: Object.assign(prevState.validationFieldsTouched, { geoLocateRadius: true })
      };
    });
  }

  toggleConsumerMessaging = () => {
    this.setState(prevState => {
      return {
        allowConsumerMessaging: !prevState.allowConsumerMessaging
      };
    });
  }

  toggleHasNoTrigger = () => {
    this.setState(prevState => {
      return {
        hasNoTrigger: !prevState.hasNoTrigger
      };
    });
  }

  onDropTriggerImage(acceptedFiles) {
    this.setState({
      acceptedTriggerImage: acceptedFiles[0]
    });
  }

  updateField(field, value) {
    this.setState((prevState) => ({
      [field]: value,
      validationFieldsTouched: Object.assign(prevState.validationFieldsTouched, { [field]: true })
    }));
  }

  updateMeasuringUnit(selectedOption) {
    this.setState({
      measuringUnit: selectedOption
    });
  }

  updatePlane(value) {
    this.setState({
      plane: value
    })
  }

  mapStatistics(statistics) {
    if (!statistics) return null;
    if (!statistics[0]) return null;

    statistics = statistics[0];

    //DNI: TODO make statistics endpoints stable
    return [{
      storage_available: statistics.storage_available,
      storage_used: statistics.storage_used,
      traffic_available: statistics.traffic_available,
      traffic_used: statistics.traffic_used,
      products: {
        favourites: statistics.favourites,
        shares: statistics.shares,
        views: statistics.views,
        websiteVisits: statistics.websiteVisits
      }
    }]
  }

  resetValidationTouched = () => {
    this.setState({
      validationFieldsTouched: {
        name: false,
        productLink: false,
        price: false,
        description: false,
        range: false,
        width: false,
        height: false,
        geoLocateRadius: false,
        triggerImageSize: false,
        modelFiles: false
      }
    })
  }

  render() {
    const { user, role } = this.props;
    const userBlocked = store.getState().userStatus.userBlocked;
    if (3 === role) {
      return <Redirect to="/s/dashboard" />
    }

    if (!user) {
      return <Redirect to="/login" />
    }

    const { completed, error, redirectWhenDoneRoute, requesting, statistics, product, setConversionsBefore, pageType } = this.props;
    const { validationFieldsTouched } = this.state;

    const productStatistics = this.mapStatistics(statistics);

    if (completed) {
      // this is called only on new products
      setConversionsBefore(product.conversionsBefore);
      return <Redirect to={redirectWhenDoneRoute} />
    }

    const renderedImageUpload = this.renderProductImageUpload(userBlocked);
    const renderedTriggerImageUpload = this.renderTriggerImageUpload(userBlocked);
    return (
      <div className={`${role === 3 ? "superadmin" : ""}`}>
        {role === 3 ? <SuperAdminHeader /> : <Header />}
        <Subheader breadcrumbs={[{ title: "Product Gallery", link: "/products" }, `${pageType === "edit" ? "Edit Product" : "New Product"}`]} />
        {!productStatistics ? '' :
          <div className="stastistics-subheader">
            <div className="container mb-5">
              <StatisticsTiles statistics={productStatistics} products={productStatistics[0].products} />
            </div>
          </div>
        }
        <Container className="mt-7">
          {error ? <Alert message={error} /> : null}
          <Row className="xs-gutters">
            <div className="col-12 mb-1">
              <h4>Basic information</h4>
            </div>
            <div className="col-12">
              <div className="panel panel-default mb-1">
                <div className="panel-body panel-body--md">
                  <Row>
                    <Col xs="12">
                      <div className="form-group row no-gutters mb-0">
                        <label htmlFor="inputEmail3" className="col-3 col-form-label pr-1">Product Name*:</label>
                        <div className="col-9 pt-1">
                          <input
                            disabled={userBlocked}
                            type="text"
                            placeholder="Enter name"
                            className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("name", error, validationFieldsTouched.name)}`}
                            value={this.state.name}
                            onChange={e => this.updateField("name", e.target.value)}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Row>


          <Row className="xs-gutters mb-2 py-2">
            <Col xs="3">
              <div className="panel panel-default mb-0 height-100">
                <div className="panel-body panel-body--md upload-product-image-box d-flex align-items-center justify-content-center height-100">
                  {renderedImageUpload}
                </div>
              </div>
            </Col>
            <Col xs="9">
              <div className="panel panel-default mb-0">
                <div className="panel-body panel-body--md">
                  <Row>
                    <div className="col-6">
                      <div className="form-group row no-gutters mb-0 mt-0">
                        <label htmlFor="inputEmail3" className="col-4 col-form-label">Product Tags:</label>
                        <div className="col-8 pt-1">
                          <AsyncCreatable
                            className="advanced-select"
                            multi={true}
                            arrowRenderer={null}
                            placeholder=''
                            value={this.state.productTagOptions}
                            onChange={this.updateProductTags}
                            loadOptions={this.getTagSuggestions}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="form-group row no-gutters mb-0 mt-0">
                        <label htmlFor="inputEmail3" className="col-4 col-form-label">Web Link*:</label>
                        <div className="col-8 pt-1">
                          <input
                            disabled={userBlocked}
                            id="inputEmail3"
                            type="text" placeholder="Enter external link"
                            value={this.state.productLink}
                            onChange={e => this.updateField("productLink", e.target.value)}
                            className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("productLink", error, validationFieldsTouched.productLink)}`}
                          />
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>

                <div className="panel panel-default mb-0">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <div className="col-12">
                        <div className="form-group row no-gutters">
                          <label htmlFor="inputEmail3" className="col-2 col-form-label pr-1">Description*:</label>
                          <div className="col-10 pt-1">
                            <textarea
                              disabled={userBlocked}
                              className={`form-control ${ErrorHelper.getValidationErrorClass("description", error, validationFieldsTouched.description)}`}
                              rows="5"
                              placeholder="No more than 1000 characters"
                              maxLength="1000"
                              value={this.state.description}
                              onChange={e => this.updateField("description", e.target.value)}>
                            </textarea>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="form-group row mt-4 mb-0 no-gutters">
                          <label htmlFor="inputEmail3" className="col-9 col-form-label">Allow User Messaging:</label>
                          <div className="col-3 d-flex align-items-center">
                            <Switch
                              onClick={this.toggleConsumerMessaging}
                              on={this.state.allowConsumerMessaging}
                              className="switch-button switch-button-xs"
                              enabled={!userBlocked}
                            />
                          </div>
                        </div>
                      </div>
                    </Row>
                  </div>
                </div>
              </div>

            </Col>
          </Row>
          <Row className="xs-gutters mt-4">
            <div className="col-12 mb-1">
              <h4>Extra information:</h4>
            </div>
            <div className="col-6">
              <div className="panel panel-default mb-1">
                <div className="panel-body panel-body--md">
                  <Row>
                    <div className="col-3">
                      <div className="form-group row no-gutters mb-0">
                        <label htmlFor="inputEmail3" className="col-6 col-form-label">Height:</label>
                        <div className="col-6 d-flex align-items-center">
                          <input
                            disabled={userBlocked}
                            type="number"
                            placeholder=""
                            className={`form-control form-control-xs p-1 ${ErrorHelper.getValidationErrorClass("height", error, validationFieldsTouched.height)}`}
                            value={this.state.height}
                            onChange={e => this.updateField('height', e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group row no-gutters mb-0">
                        <label htmlFor="inputEmail3" className="col-6 col-form-label">Width:</label>
                        <div className="col-6 d-flex align-items-center">
                          <input
                            disabled={userBlocked}
                            type="number"
                            placeholder=""
                            className={`form-control form-control-xs p-1 ${ErrorHelper.getValidationErrorClass("width", error, validationFieldsTouched.width)}`}
                            value={this.state.width}
                            onChange={e => this.updateField('width', e.target.value)}
                          />

                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group row no-gutters mb-0 ">
                        <label htmlFor="inputEmail3" className="col-7 col-form-label pr-1 text-right">Unit:</label>
                        <div className="col-5">
                          <Select
                            disabled={userBlocked}
                            name="product-currency pt-1"
                            className="advanced-select ml-2"
                            value={this.state.measuringUnit}
                            onChange={this.updateMeasuringUnit}
                            options={measuringUnits}
                          />
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="panel panel-default mb-1">
                <div className="panel-body panel-body--md">
                  <div className="form-group row no-gutters mb-0">
                    <label htmlFor="inputEmail3" className="col-4 col-form-label pr-1">Set price:</label>
                    <div className="col-5 pt-1">
                      <input
                        disabled={userBlocked}
                        type="number"
                        placeholder="Enter price"
                        className={`form-control form-control-xs mr-2 ${ErrorHelper.getValidationErrorClass("price", error, validationFieldsTouched.price)}`}
                        value={this.state.price}
                        onChange={e => this.updateField("price", e.target.value)}
                      />
                    </div>
                    <div className="col-3">
                      <Select
                        disabled={userBlocked}
                        name="product-currency pt-1"
                        className="advanced-select ml-2"
                        value={this.state.productCurrency}
                        onChange={option => this.updateField("productCurrency", option)}
                        options={currencyOptions}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Row>

          <Row className="xs-gutters mt-4">
            <div className="col-12 mb-1">
              <h4>Upload files:</h4>
            </div>
            <div className="col-12">
              <ModelFileDrop
                disabled={userBlocked}
                files={this.state.modelFiles}
                errors={this.state.modelErrors}
                conversionStarted={this.state.modelConvertionStarted}
                conversionsBefore={this.state.conversionsBefore}
                modelInvalid={this.state.modelInvalid}
                onChange={modelFiles => this.updateField("modelFiles", modelFiles)}
                parentValidation={{
                  touched: validationFieldsTouched.modelFiles,
                  error: error
                }}
              />
            </div>
          </Row>

          <Row className="xs-gutters mt-4">
            <div className="col-12 mb-1">
              <h4>Triggers:</h4>
            </div>
            <div className="col-12">
              <div className="panel panel-default mb-1">
                <div className="panel-body panel-body--md pb-2">
                  <Row>
                    <Col xs="2">
                      <p>No trigger</p>
                    </Col>
                    <Col xs="1">
                      <Switch
                        onClick={this.toggleHasNoTrigger}
                        on={this.state.hasNoTrigger}
                        className="switch-button switch-button-xs"
                        enabled={!userBlocked}
                      />
                    </Col>
                    <Col xs="9">
                      <p>Check only if your object doesn't need a trigger to be displayed.</p>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            <div className="col-12 mt-2">
              <div className="panel panel-default mb-1">
                <div className="panel-body panel-body--md pb-2">
                  <Row className="align-items-center">
                    <Col xs="2">
                      <p>Image</p>
                    </Col>
                    <Col xs="1">
                      <Switch
                        onClick={this.togglehasImageTrigger}
                        on={this.state.hasImageTrigger}
                        className="switch-button switch-button-xs"
                        enabled={!userBlocked}
                      />
                    </Col>
                    <Col xs="9">
                      {this.state.hasImageTrigger ?
                        <Row className="align-items-center">
                          <Col xs="6">
                            <Row className="align-items-center">
                              <div className="align-items-center">
                                <label>Physical Width:</label>
                              </div>
                              <div className="align-items-center ml-2">
                                <input
                                  disabled={userBlocked}
                                  type="number"
                                  placeholder=""
                                  className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("triggerImageSize", error, validationFieldsTouched.triggerImageSize)}`}
                                  value={this.state.triggerImageSize}
                                  onChange={e => this.updateField("triggerImageSize", e.target.value)}
                                />
                              </div>
                              <div className="align-items-center ml-2">
                                <Select
                                  disabled={userBlocked}
                                  name="trigger-image-unit"
                                  className="advanced-select"
                                  value={this.state.imageTriggerUnit}
                                  onChange={(e) => this.setState({ imageTriggerUnit: e })}
                                  options={measuringUnits}
                                />
                              </div>
                            </Row>
                          </Col>
                          <Col xs="6" className="text-center">
                            {renderedTriggerImageUpload}
                          </Col>
                        </Row>
                        : <p>Check only if your object can be triggerd by a image.</p>}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            <div className="col-12 mt-2">
              <div className="panel panel-default mb-1">
                <div className="panel-body panel-body--md pb-2">
                  <Row>
                    <Col xs="2">
                      <p>Plane</p>
                    </Col>
                    <Col xs="1">
                      <Switch
                        onClick={this.togglehasPlaneTrigger}
                        on={this.state.hasPlaneTrigger}
                        className="switch-button switch-button-xs"
                        enabled={!userBlocked}
                      />
                    </Col>
                    <Col xs="9">
                      {this.state.hasPlaneTrigger ?
                        <Row className="xs-gutters">
                          <Col xs="8">
                            <RadioGroup name="plane" selectedValue={this.state.plane} onChange={this.updatePlane} disabled={userBlocked}>
                              <Radio value="horizontal" /> <span className="ml-2 mr-4">Horizontal</span>
                              <Radio value="vertical" /> <span className="ml-2 mr-4">Vertical</span>
                            </RadioGroup>
                          </Col>
                          <Col xs="4">
                            <div className="form-group row mb-0 no-gutters">
                              <label htmlFor="inputEmail3" className="col-6">Elevation (cm):</label>
                              <div className="col-6 align-items-center">
                                <input
                                  disabled={userBlocked}
                                  type="number"
                                  value={this.state.elevation}
                                  placeholder="Elevation"
                                  className="form-control form-control-xs nmt-8"
                                  onChange={e => this.updateField('elevation', e.target.value)}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        : <p>Check only if you object needs a vertical or horizontal plane, to be displayed.</p>}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            <div className="col-12 mt-2">
              <div className="panel panel-default mb-1">
                <div className="panel-body panel-body--md pb-2">
                  <Row>
                    <Col xs="2">
                      <p>GPS</p>
                    </Col>
                    <Col xs="1">
                      <Switch
                        onClick={this.togglehasGeolocation}
                        on={this.state.hasGeolocation}
                        className="switch-button switch-button-xs"
                        enabled={!userBlocked}
                      />
                    </Col>
                    <Col xs="9">
                      {this.state.hasGeolocation ?
                        <div className="panel panel-default mb-1">
                          <div className="panel-body panel-body--md p-0">
                            <Row className="mb-4">
                              <Col xs="3">
                                <p>Epicenter and range</p>
                              </Col>
                              <Col xs="6 justify-content-end">
                                <p>{this.state.address}</p>
                              </Col>
                              <Col xs="3">
                                <input
                                  disabled={userBlocked}
                                  type="number"
                                  placeholder="Location radius (meters)"
                                  className={`form-control form-control-xs nmt-8 ${ErrorHelper.getValidationErrorClass('geoLocateRadius', error, validationFieldsTouched.geoLocateRadius)}`}
                                  value={this.state.geoLocateRadius}
                                  onChange={e => this.updateField('geoLocateRadius', e.target.value)}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <MapWithASearchBox
                                  disabled={userBlocked}
                                  centerOn={this.state.geoLocation}
                                  onSetMarker={(position) => { this.updateLocation(position) }}
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                        : <p>Check only to set coordinates as trigger.</p>}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Row>

          <Row className="xs-gutters mt-2">
            <Col xs="8 btn-semi-dark">
            </Col>
            <Col xs="2">
              <button className="btn btn-semi-dark btn-block btn-lg upload-product__control-panel-item text-uppercase" onClick={this.cancelStepThree}>Back</button>
            </Col>
            <Col xs="2">
              <button
                className="btn btn-primary btn-lg btn-block upload-product__control-panel-item text-uppercase"
                disabled={requesting || userBlocked ? 'disabled' : ''}
                onClick={this.uploadProduct}
              >
                {!requesting ? this.props.submitActionName : ''}
                <ClipLoader
                  color={'#FFFFFF'}
                  loading={requesting}
                  className=""
                />
              </button>

            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }

}

export default ProductPage



// WEBPACK FOOTER //
// ./src/components/Product/ProductPage.js